export default "__VITE_ASSET__ccb9d329__"